module.exports = __webpack_public_path__ + "static/media/6.3370b9e6.jpg";